import { getShareConversationListApi, createShareSessionApi } from '@api/robot';
import { message } from '@koi-design/uxd-ui';
import i18n from '@/locales/i18n';

const app = {
  state: {
    showConversationList: false,
    sessionList: [],
    curSessionId: ''
  },
  mutations: {
    addShareSessionList(state, val) {
      state.sessionList.unshift(val);
    },
    setShareConversationListStatus(state) {
      state.showConversationList = !state.showConversationList;
    },
    closeShareStatus(state) {
      state.showConversationList = false;
    },
    setShareSessionList(state, val) {
      state.sessionList = val;
    },
    setCurSessionId(state, val) {
      if (val === state.curSessionId) {
        message.error(
          i18n.global.t('views.botWeb.index.b511a1df615db3f769fc98d327881306')
        );
        return;
      }
      state.curSessionId = val;
    }
  },
  actions: {
    async getShareSessionList({ commit }, params) {
      const res = await getShareConversationListApi({
        user_code: localStorage.getItem('temVisitId'),
        ...params
      });
      if (res.length) {
        commit('setShareSessionList', res);
      } else {
        const newConversation = await createShareSessionApi({
          ...params,
          user_code: localStorage.getItem('temVisitId'),
          message_source: 'web_share'
        });
        commit('setShareSessionList', [newConversation]);
      }
    },
    async createShareSession({ commit }, params) {
      const res = await createShareSessionApi({
        message_source: 'web_share',
        ...params
      });
      commit('setCurSessionId', res.segment_code);

      return res.segment_code;
    }
  },
  getters: {
    showShareConversationList: state => state.showConversationList,
    sessionShareList: state => state.sessionList,
    curSessionId: state => state.curSessionId
  }
};

export default app;
